import React, { useMemo } from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";
import { formatPen } from "../../../../utils/finance/format";

function toChartData(series) {
  const arr = series?.sales_by_day || [];
  return arr.map((x) => ({
    date: x.date,
    total: Number(x.total || 0),
  }));
}

export function FinanceDailySalesChart({ series }) {
  const data = useMemo(() => toChartData(series), [series]);

  return (
    <Card sx={{ borderRadius: 6 }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>Daily sales</Typography>

        <Box sx={{ height: 320 }}>
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 12 }} />
              <Tooltip
                formatter={(value) => [formatPen(value), "Ventas"]}
                labelFormatter={(label) => `Fecha: ${label}`}
              />
              <Area type="monotone" dataKey="total" strokeWidth={2} dot={false} />
            </AreaChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </Card>
  );
}
